import { Localizable } from '@components/localizable/Localizable'
import { SBFormItemAddon } from '@components/SBFormItemAddon'
import { ProgramCurrency as ProgramCurrencyModel } from '@models/membership/ProgramCurrency'
import { selectCurrencyById } from '@store/CurrencyReducer'
import { useAppSelector } from '@store/hooks'
import { selectMembershipProfileCurrencyById } from '@store/membership/MembershipProfileCurrencyReducer'
import { selectProgramCurrencyById } from '@store/membership/ProgramCurrencyReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { numberRule, requiredRule } from '@utils/rules'
import { Form, InputNumber, Typography } from 'antd'
import { FC, useEffect } from 'react'

const { Text } = Typography

type Props = SBModelComponent<ProgramCurrencyModel> & {
  entity: 'program' | 'membershipProfile'
}

const selector = {
  program: selectProgramCurrencyById,
  membershipProfile: selectMembershipProfileCurrencyById,
}

export const CurrencyInput: FC<Props> = ({ entity, id, model }: Props) => {
  const item = model ?? useAppSelector(selector[entity](id!))
  const currency = useAppSelector(selectCurrencyById(item?.currency!))

  const form = Form.useFormInstance()

  if (!item || !currency) {
    return <></>
  }

  useEffect(() => {
    form.setFieldsValue({
      amount: {
        [item.id]: item.amount,
      },
    })
  }, [item, form])

  return (
    <SBFormItemAddon
      formItemProps={{
        label: (
          <Localizable.Render
            item={item}
            render={(localizedItem, lang) => (
              <Text>
                {lang.flag} {localizedItem.name}
              </Text>
            )}
          />
        ),
        name: ['amount', item.id],
        rules: [requiredRule(), numberRule()],
        required: true,
      }}
      addonAfter={currency.symbol}
    >
      <InputNumber className="w-full" />
    </SBFormItemAddon>
  )
}
